import { HostingVersionCatalogue, ReleaseFamily } from '@feedyou-ai/feedbot-schema'
import _ from 'lodash'
import semver from 'semver'

export const getAllReleases = (catalogue: HostingVersionCatalogue): ReleaseFamily[] =>
  Object.keys(catalogue) as ReleaseFamily[]

export function getAllActiveReleases(catalogue: HostingVersionCatalogue): ReleaseFamily[] {
  return getAllReleases(catalogue).filter(release => !!catalogue[release]?.versions.length)
}

export function compareHostingVersions(v1: string, v2: string) {
  const semver1 = semver.coerce(v1)
  const semver2 = semver.coerce(v2)

  if (!semver1 && !semver2) {
    if (v2 > v1) return 1
    if (v2 < v1) return -1
    return 0
  }

  if (!semver1) return 1
  if (!semver2) return -1

  return semver.compare(semver1, semver2)
}

export function sortCatalogueVersions(catalogue: HostingVersionCatalogue): HostingVersionCatalogue {
  return _.mapValues(catalogue, (val, key) => {
    if (key === ReleaseFamily.Release && val && val.versions?.length) {
      // Partition the array into invalid and valid semver objects
      const invalid = val.versions.filter(item => !semver.valid(item.version))
      const valid = val.versions.filter(item => semver.valid(item.version))

      // Sort the valid versions in descending order
      valid.sort((a, b) => semver.rcompare(a.version, b.version))

      // Return a new array with invalid items first, then the sorted valid ones
      return {
        ...val,
        versions: invalid.concat(valid)
      }
    }

    return val
  })
}

export function truncateCommit(commit: string) {
  return commit.slice(0, 8)
}
